module.exports = __webpack_public_path__ + "static/media/img-benefit-bonus@2x.4fb394d7.png";